import { render, staticRenderFns } from "./DashboardAitBreakdown.vue?vue&type=template&id=9095eb54"
import script from "./DashboardAitBreakdown.vue?vue&type=script&lang=js"
export * from "./DashboardAitBreakdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports